import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import {
  deleteJournalEntry,
  DELETE_JOURNAL_ENTRY_KEY,
} from '@/actions/admin/journalEntryActions'
import { selectIsFetchingForKeys } from '@/reducers/fetch'

import { Dialog, Button, Text } from '@/ui'
import { JournalEntry } from '../types'
import { JournalEntryCard } from './JournalEntryTransactionRow'

// TODO: Migrate to V2
import {
  JournalEntryUpdateType,
  MaybeJournalEntry,
} from '@/componentsV1/Admin/PaginatedTransactionTable/RowDrawer'
import { TypographyStyles } from '@/styles'

interface DeleteJournalEntraModalProps {
  onClose: () => void
  open: boolean
  journalEntry: JournalEntry
  userId: number
  onUpdate?: (
    journalEntry: MaybeJournalEntry,
    type: JournalEntryUpdateType
  ) => void
}

export const DeleteJournalEntryModal = ({
  onClose,
  open,
  journalEntry,
  userId,
  onUpdate = (_: MaybeJournalEntry, _2: JournalEntryUpdateType) => undefined,
}: DeleteJournalEntraModalProps) => {
  const dispatch = useAppDispatch()

  const loading = useReselector(selectIsFetchingForKeys, [
    DELETE_JOURNAL_ENTRY_KEY,
  ])

  const handleDelete = async () => {
    const res = await deleteJournalEntry(journalEntry.id)(dispatch)
    if (res) {
      onUpdate(res, JournalEntryUpdateType.DELETE)
      onClose()
    }
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Content className="max-w-xl p-8">
        <Dialog.Title>
          <Text variant={TypographyStyles.H2} className="mb-8">
            Confirm journal entry deletion
          </Text>
        </Dialog.Title>

        <Text className="mb-4">
          Are you sure you want to delete this journal entry?
        </Text>

        <JournalEntryCard
          journalEntry={journalEntry}
          userId={userId}
          deleting
        />

        <Text className="font-bold mt-4" variant={TypographyStyles.BODY_MD}>
          It cannot be recovered.
        </Text>

        <Dialog.Footer className="mt-8 flex justify-between">
          <Dialog.Close asChild>
            <Button variant="link" className="mr-4">
              Cancel
            </Button>
          </Dialog.Close>
          <Dialog.Close asChild>
            <Button variant="danger" onClick={handleDelete} loading={loading}>
              Delete Journal Entry
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
